import React, { useState } from 'react';

const DEFAULT_STATE = {
	siderOpen: false
};	

const LayoutContext = React.createContext(DEFAULT_STATE);
const LayoutContextConsumer = LayoutContext.Consumer;

const LayoutContextProvider = ({ children }) => {
	const [siderOpen, setSiderOpen] = useState(DEFAULT_STATE.siderOpen);

	const updateSiderOpen = siderOpen => {
		setSiderOpen(siderOpen);
	};

	return (
		<LayoutContext.Provider value={{
			siderOpen: siderOpen,
			updateSiderOpen: updateSiderOpen
		}}>	
			{children}
		</LayoutContext.Provider>
	)
};

export { LayoutContext, LayoutContextProvider, LayoutContextConsumer };

